import reducers from './reducers';

// Named exports for types, selectors, and operations
export { default as categoriesTypes } from './types';
export { default as categoriesSelectors } from './selectors';
export { default as categoriesOperations } from './operations';

// Default export is the reducers
export default reducers;
